// Telas em que a barra inferior do shell mobile fica visível: Início, Minhas
// Ordens, Orçamentos e Mais (apenas a rota de listagem raiz de cada uma).
// Qualquer outra tela (detalhes, formulários, demais módulos) oculta a barra.
const BOTTOM_NAV_VISIBLE_PATHS = ['/home', '/serviceorders', '/servicequotes', '/more'];

export function isBottomNavVisible(pathname) {
    const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
    return BOTTOM_NAV_VISIBLE_PATHS.includes(normalized);
}
